import React from "react";

export interface PollIntervalContextValue {
  /**
   * Register a callback to be invoked on every interval tick.
   * Returns an unsubscribe function — call it (or return it from a useEffect) to deregister.
   */
  subscribe: (callback: () => void) => () => void;
}

/**
 * Default no-op value used when a consumer renders outside a {@link PollIntervalProvider}.
 * Subscribing against this default is safe (the returned unsubscribe is also a no-op),
 * but no ticks will ever fire.
 */
const PollIntervalContext = React.createContext<PollIntervalContextValue>({
  subscribe: () => () => undefined,
});

export default PollIntervalContext;
